var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "licenseTitle"
  }, "License") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "licenseTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 27,
    x: 5,
    y: -3.5,
    stroke: "#292929",
    rx: 2.25,
    transform: "rotate(-90 14 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 17,
    y: 6.5,
    fill: "#292929",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 17,
    y: 9.5,
    fill: "#292929",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 17,
    y: 12.5,
    fill: "#292929",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 6.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.5,
    r: 1,
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 4.5,
    r: 1,
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    d: "M2.07511737 2.5258216L7.92488263 2.5258216C9.07093831 2.5258216 10 3.45488329 10 4.60093897L10 6.5258216 10 6.5258216 0 6.5258216 0 4.60093897C3.03737868e-16 3.45488329.929061693 2.5258216 2.07511737 2.5258216zM7.18309859 7L7.18309859 7.18779343C7.18309859 7.75822838 7.64552749 8.22065728 8.21596244 8.22065728 8.78639739 8.22065728 9.24882629 7.75822838 9.24882629 7.18779343L9.24882629 7M.751173709 7L.751173709 7.18779343C.751173709 7.75822838 1.21360261 8.22065728 1.78403756 8.22065728 2.35447251 8.22065728 2.81690141 7.75822838 2.81690141 7.18779343L2.81690141 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    d: "M1.03286385,2.94117647 L1.40287091,1.09535437 C1.53144607,0.45394264 2.02416908,-4.28324043e-13 2.59180152,-4.28324043e-13 L7.45514683,-4.28324043e-13 C8.02277928,-4.28324043e-13 8.51550228,0.45394264 8.64407744,1.09535437 L9.01408451,2.94117647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLicense);
export default __webpack_public_path__ + "static/media/mob-license.bb9a6ceef406bcabb0cd0baf69929ce6.svg";
export { ForwardRef as ReactComponent };